import { render, staticRenderFns } from "./groupCheckout.vue?vue&type=template&id=bdcf795a"
import script from "./groupCheckout.vue?vue&type=script&lang=js"
export * from "./groupCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports